import { Institution } from '@/domain/entities/institution.entity'
import { ICourseService, IInputUpdateCourse } from '../contracts/courses'
import { Course } from '../../domain/entities/course.entity'
import api, { HttpResponse, treatmentForErrors } from '../api'

export class CoursesService implements ICourseService {
  async loadByStudentId(id: number): Promise<
    HttpResponse<
      {
        data: {
          courses: Course
          institutions: Institution
          registrations: Course[]
        }
      },
      Error
    >
  > {
    const request = api.get(`/courses/by-student-id/${id}`)
    return treatmentForErrors(request)
  }

  async loadById(id: number): Promise<HttpResponse<Course, Error>> {
    const request = api.get(`/courses/${id}`)
    return treatmentForErrors(request)
  }

  async delete(id: string): Promise<HttpResponse<Course, Error>> {
    const request = api.delete(`/admin/courses/${id}`)
    return treatmentForErrors(request)
  }

  async loadAll(): Promise<HttpResponse<{ courses: Course[] }, Error>> {
    const request = api.get('/courses')
    return treatmentForErrors(request)
  }

  async update(course: Course): Promise<HttpResponse<Course, Error>> {
    const request = api.put(`/admin/courses/${course.id}`, course)
    return treatmentForErrors(request)
  }

  async updateRegistered({
    id,
    course,
  }: IInputUpdateCourse): Promise<HttpResponse<Course, Error>> {
    const request = api.put(`/courses/${id}`, course)
    return treatmentForErrors(request)
  }
}
